var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Object3D',{attrs:{"position":_vm.pos,"rotation":_vm.rot}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }